<template>
  <div class="box">
    <h3 class="sub_tit">{{ $t('library.bookdetailbox.6122') }}</h3>
    <div class="box_inner line">
      <dl class="meta_specific sbook">
        <!-- <dt>{{ $t('library.bookdetailbox.8905') }}</dt>
        <dd>{{ book.date || '-' }}</dd> -->
        <!-- <template v-if="book.buyTp.ebook">
          <dt>{{ $t('library.bookdetailbox.ebook') }}</dt>
          <dd>{{ book.contentSize || '-' }}MB</dd>
        </template>
        <template v-if="book.bookSize">
          <dt>{{ $t('library.bookdetailbox.6262') }}</dt>
          <dd>{{ book.bookSize || '-' }}</dd>
        </template> -->
        <template v-if="book.isbn13">
          <dt>{{ $t('library.bookdetailbox.isbn') }}</dt>
          <dd>{{ book.isbn13 || '-' }}</dd>
        </template>
        <template v-if="book.isbn10">
          <dt>{{ $t('library.bookdetailbox.isbn1') }}</dt>
          <dd>{{ book.isbn10 || '-' }}</dd>
        </template>
        <template v-if="book.contentPages">
          <dt>{{ $t('library.bookdetailbox.194') }}</dt>
          <dd>
            {{ book.contentPages }}{{ $t('library.bookdetailbox.pages') }}
          </dd>
        </template>
        <template v-if="getSupplementExists">
          <dt>보조자료</dt>
          <dd class="flex_wrap">
            <span class="ellipsis_wrap">
              {{ getSupplementFileNames[0] }}
            </span>
            <span v-if="getSupplementFileNames.length > 1">
              외 {{ getSupplementFileNames.length - 1 }}건
            </span>
          </dd>
        </template>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BookDetailBox',
  props: {
    book: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['getSupplementExists', 'getSupplementFileNames'])
  },
  methods: {
    checkSupplement() {
      // if (this.getStoreCurrentBook?.suppleMent === 'Y') {
      //   return true
      // }
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
.detail_book_introduce .box .box_inner.line {
  display: inline-block;
  width: 100%;
  padding: 30px 65px 30px 65px;
  border: 4px solid #f0f5fa;
  border-radius: 8px;
  margin-bottom: -48px;
}
.detail_book_introduce .meta_specific dt,
.detail_book_introduce .meta_specific dd {
  float: left;
}
.detail_book_introduce .meta_specific dt {
  width: 84px;
  font-family: 'pretendard-medium';
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  color: #000000;
}
.detail_book_introduce .meta_specific dd {
  font-family: 'pretendard-light';
  width: 266px;
  width: calc((100% - 222px - 150px) / 2 - 1px);
  font-size: 13px;
  line-height: 24px;
  letter-spacing: 0;
}
.detail_book_introduce .meta_specific dd:nth-child(6n) {
  width: 120px;
}
.flex_wrap {
  display: flex;
}
.ellipsis_wrap {
  width: 124px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .flex_wrap {
    justify-content: flex-end;
  }
  .ellipsis_wrap {
    width: 150px;
  }
  .detail_book_introduce .box .box_inner.line {
    padding: 5%;
  }
  .detail_book_introduce .meta_specific {
    position: relative;
  }
  .detail_book_introduce .meta_specific dt {
    width: 50%;
    font-size: 12px;
  }
  .detail_book_introduce .meta_specific dd,
  .detail_book_introduce .meta_specific dd:nth-child(6n) {
    width: 50%;
    text-align: right;
    font-size: 12px;
  }
  .detail_book_introduce .meta_specific dt:nth-child(1),
  .detail_book_introduce .meta_specific dd:nth-child(2),
  .detail_book_introduce .meta_specific dt:nth-child(3),
  .detail_book_introduce .meta_specific dd:nth-child(4) {
    margin-bottom: 44px;
  }
  .detail_book_introduce .meta_specific dt:nth-child(7),
  .detail_book_introduce .meta_specific dd:nth-child(8),
  .detail_book_introduce .meta_specific dt:nth-child(9),
  .detail_book_introduce .meta_specific dd:nth-child(10),
  .detail_book_introduce .meta_specific dt:nth-child(11),
  .detail_book_introduce .meta_specific dd:nth-child(12) {
    margin-bottom: 0px;
  }
  .detail_book_introduce .meta_specific.sbook dt:nth-child(1),
  .detail_book_introduce .meta_specific.sbook dd:nth-child(2),
  .detail_book_introduce .meta_specific.sbook dt:nth-child(3),
  .detail_book_introduce .meta_specific.sbook dd:nth-child(4),
  .detail_book_introduce .meta_specific.sbook dt:nth-child(5),
  .detail_book_introduce .meta_specific.sbook dd:nth-child(6) {
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f5fa;
  }
}
@media (max-width: 480px) {
  .box .box_inner.line {
    border: 4px solid #e3e8e9;
  }
  .ellipsis_wrap {
    width: 110px;
  }
}
</style>
